// extracted by mini-css-extract-plugin
export default {"Button":"EditButton_Button__PsU5+"};